import {Orders} from "../models/Orders";
import {Box} from "../models/Box";
import {BASE_URLS} from "../config/urls";
import {apiFetch} from "../utils/api";

export class OrderService {

    async create(order: Orders, boxes: Box[]) {
        const body = JSON.stringify({ order, boxes });
        const res = await apiFetch(`${BASE_URLS.api}/new_order`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body
        });
        return res.json();
    }
}
